<template>
  <div
    class="cart-drawer"
    :class="{ 'cart-drawer--active': active && isCartInit }"
  >
    <div class="cart-drawer__backdrop" @click="handleBackdropClick" />
    <div class="cart-drawer__wrapper text--clr-black">
      <div
        class="cart-drawer__content-scrollcontainer flex--col-start-center"
        ref="cartDrawerContent"
      >
        <div class="cart-drawer__content-stretcher">
          <div class="cart-drawer__sticky-head noselect">
            <div class="cart-drawer__title">
              <p
                class="cart-drawer__title-copy text--uppercase text-zd-cart-drawer-title"
              >
                {{
                  `${getCartTotalQuantity} ${UI_ELEMENT(
                    getCartTotalQuantity == 1
                      ? "cart_title_quantity_singular"
                      : "cart_title_quantity_plural"
                  )}`
                }}
              </p>
              <Cross class="cart-drawer__close-cross" @click="CLOSE_CART" />
            </div>
            <CartUpsell />
          </div>
          <div class="cart-drawer__line-items">
            <div class="text-body text--center">
              <span class="cart-drawer__empty-text mt-32" v-if="getIsCartEmpty">
                {{ UI_ELEMENT("cart_drawer_empty_cart") }}
              </span>
              <RichText
                :content="UI_TEXT_CONTENT('cart_drawer_empty_link')"
                class="cart-drawer__empty-link mt-8"
                v-if="getIsCartEmpty"
              />
            </div>
            <CartEntry
              class="cart-drawer__line-item-entry"
              v-for="lineItem in getAdjustedLineItems"
              :key="
                lineItem.product.displayTitle +
                  JSON.stringify(lineItem.customData)
              "
              :lineItem="lineItem"
            />
            <CartGwpEntry class="cart-drawer__line-item-entry" />
          </div>
        </div>
        <ProductMiniCarousel
          class="cart-drawer__missed-products"
          mini
          v-if="active && getMissedProducts.length > 0"
          :title="UI_ELEMENT('cart_drawer_upsell_title_refresh')"
          :products="getMissedProducts"
        />
        <div class="cart-drawer__total">
          <div class="cart-drawer__total-row text-commerce-heading-3">
            <div>
              {{ UI_ELEMENT("cart_header_subtotal") }}
            </div>
            <PriceRenderer
              :price="getCartTotal"
              :compareAtPrice="getCartCompareAtTotal"
            />
          </div>
          <span class="cart-drawer__discounts text-body-small mr-2">
            <template v-if="GET_HAS_GLOBAL_PRICE_ADJUSTMENT">
              <RichText
                baseClass="text-body-small"
                :content="
                  UI_TEXT_CONTENT('cart_message_shipping_discount_applied', [
                    {
                      tag: 'DISCOUNT_CODE',
                      value: globalDiscount.discountCode
                    },
                    {
                      tag: 'DISCOUNT_VALUE',
                      value: globalDiscount.discountValue
                    }
                  ])
                "
              />
            </template>
            <template v-else>
              {{ UI_ELEMENT("cart_message_shipping") }}
            </template>
          </span>

          <BasicButton
            class="cart-drawer__total-checkout text-zd-button-xlarge"
            :class="{
              'cart-drawer__total-checkout--disabled': getIsCartEmpty
            }"
            large
            @click="checkout"
            :disabled="getIsCartEmpty"
          >
            {{ UI_ELEMENT("cart_button_checkout") }}
          </BasicButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex"

import CartEntry from "./CartEntry.vue"
import CartGwpEntry from "./CartGwpEntry.vue"
import CartUpsell from "./CartUpsell.vue"
import ProductMiniCarousel from "@/components/ProductMiniCarousel.vue"
import Cross from "@/assets/cross.svg"
import RichText from "@/components/RichText"

// import {
//   disableBodyScroll,
//   enableBodyScroll,
//   clearAllBodyScrollLocks
// } from "body-scroll-lock"

// import { lockScroll, unlockScroll } from "@/helpers/ScrollLock"

import PriceRenderer from "../../components/text/PriceRenderer.vue"

export default {
  props: ["active"],

  data() {
    return {}
  },
  components: {
    RichText,
    ProductMiniCarousel,
    CartUpsell,
    CartEntry,
    CartGwpEntry,
    Cross,
    PriceRenderer
  },

  created() {
    this.uiElement_manifest = [
      "cart_title_quantity_singular",
      "cart_title_quantity_plural"
    ]
    this.initCart()
  },

  methods: {
    ...mapActions("cart", ["INIT_GWP_PROMO", "CLOSE_CART", "CHECKOUT"]),
    ...mapActions("queryParams", ["CLEAR_PARAMS"]),

    ...mapMutations("cart", ["SET_CART_INIT"]),

    handleBackdropClick() {
      this.CLOSE_CART()
    },
    checkout() {
      if (this.getIsCartEmpty) {
        return
      } else {
        this.CHECKOUT()
      }
    },

    async initCart() {
      Bleach.debug.log("*** initCart")
      // Update active GWP promo
      this.INIT_GWP_PROMO()
      this.SET_CART_INIT(true)
    }
  },
  computed: {
    ...mapState("identity", ["buuid"]),
    ...mapState("locale", ["locale"]),
    ...mapState("cart", ["isCartInit", "cartId"]),
    ...mapState("content", ["globalDiscount"]),
    ...mapGetters("cart", [
      "getIsCartActive",
      "getAdjustedLineItems",
      "getCartTotalCents",
      "getCartAdjustedTotalCents",
      "getCartTotalQuantity"
    ]),
    ...mapGetters("breakpoints", ["GET_IS_BELOW_BREAKPOINT"]),
    ...mapGetters("content", [
      "GET_SITE_CONFIG",
      "GET_PRODUCT_ENTRY",
      "GET_HAS_GLOBAL_PRICE_ADJUSTMENT"
    ]),

    getIsCartEmpty() {
      return this.getAdjustedLineItems.length == 0
    },

    getHasPriceAdjustment() {
      return this.getCartTotalCents !== this.getCartAdjustedTotalCents
    },

    getCartTotal() {
      return this.getHasPriceAdjustment
        ? { cents: this.getCartAdjustedTotalCents }
        : { cents: this.getCartTotalCents }
    },

    getCartCompareAtTotal() {
      return this.getHasPriceAdjustment
        ? { cents: this.getCartTotalCents }
        : null
    },

    // getCartTotal() {
    //   return formatPrice(
    //     { cents: this.getCartTotalCents },
    //     this.$store.state.locale
    //   )
    // },

    // getCartAdjustedTotal() {
    //   return formatPrice(
    //     { cents: this.getCartAdjustedTotalCents },
    //     this.$store.state.locale
    //   )
    // },

    getMissedProducts() {
      if (this.GET_SITE_CONFIG.cartAddOnProductListCollection) {
        return this.GET_SITE_CONFIG.cartAddOnProductListCollection.items.map(
          product =>
            !!product &&
            this.GET_PRODUCT_ENTRY(product.sys.id, product.__typename)
        )
      }

      return []
    }
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        this.CLOSE_CART()
      }
    },
    getIsCartActive(newVal) {
      if (newVal) {
        this.initCart()
      }

      // if (this.GET_IS_BELOW_BREAKPOINT("md")) {
      //   if (newVal) {
      //     // this.debug.warn("LOCKING!")
      //     // lockScroll(this.$refs["cartDrawerContent"])
      //   } else {
      //     // unlockScroll(this.$refs["cartDrawerContent"])
      //     // clearAllBodyScrollLocks()
      //   }
      // } else if (!newVal) {
      //   // unlockScroll(this.$refs["cartDrawerContent"])
      //   // clearAllBodyScrollLocks()
      // }
    }
  }
}
</script>

<style lang="scss">
.cart-drawer {
  position: fixed;
  height: 100%;
  width: 100vw;
  top: 0;
  right: 0;
  transition: opacity 0.3s ease;

  &--active {
    .cart-drawer__wrapper {
      transform: translateX(0);
    }
  }

  z-index: 5;

  @include media-breakpoint-up(md) {
    position: absolute;
    height: 100vh;
    &--active {
      .cart-drawer__backdrop {
        pointer-events: all;

        opacity: 1;
      }

      .cart-drawer__wrapper {
        transform: translateX(-490px);
      }
    }
  }

  &__backdrop {
    background: rgba(getcolour(bleach_black), 0.3);
    backdrop-filter: saturate(75%);
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    background: getcolour(bleach_white);
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    transition: transform 0.3s cubic-bezier(0.65, 0, 0.35, 1);
    transform: translateX(100%);

    display: flex;
    flex-direction: column;
    pointer-events: all;

    @include media-breakpoint-up(md) {
      right: -490px;
      width: 490px;
    }
  }

  &__divider {
    width: calc(100% - 70px);
    border-bottom: 1px solid #000000;
    height: 1px;
    margin: 14px auto 0;
  }

  &__sticky-head {
    position: sticky;
    top: 0;
    background-color: getcolour(bleach_white);
    z-index: 1;
  }

  &__title {
    display: flex;
    align-items: flex-start;
    padding: 24px 0 16px;
  }

  &__title-copy {
    position: relative;
    margin: 0 auto;
    width: 75%;
    text-align: center;
  }

  &__discounts {
    color: $bleach-grey-40;
  }

  &__empty-text {
    margin-top: 30px;
  }

  &__empty-link {
    margin-top: 8px;
  }

  &__close-cross {
    width: 20px;
    cursor: pointer;
    position: absolute;
    right: 24px;

    @include media-breakpoint-up(md) {
      right: 40px;
    }

    path {
      stroke: getcolour(bleach_black);
      vector-effect: non-scaling-stroke;
      stroke-width: 1.5px;
    }

    line {
      stroke-width: 1px;
    }
  }

  &__content-scrollcontainer {
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    height: auto;
    // min-height: 100%;
    max-height: 100%;
    max-height: 100dvh; // Declared in attempt to fix PP-2239
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding-bottom: unset;
    // padding-bottom: 200px;
    flex: 1;

    // background-color: getcolour(bleach_grey_90);

    @include media-breakpoint-up(md) {
      min-height: unset;
      max-height: unset;
    }

    // @include media-breakpoint-up(lg) {
    //   padding-bottom: 150px;
    // }
  }

  &__content-stretcher {
    flex: 1 0 auto;
    width: 100%;
  }

  &__line-items {
    opacity: 1;
    width: 100%;
    height: auto;
    padding: 32px 24px 16px;

    @include media-breakpoint-up(md) {
      padding: 32px 40px 16px;
    }
  }

  &__line-item-entry {
    border-bottom: 0.5px solid getcolour(bleach_grey_90);

    &:last-child {
      border-bottom: unset;
    }
  }

  &__missed-products {
    flex: 0 0 auto;
  }

  &__total {
    position: sticky;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background: $bleach-white;
    padding: 0 24px;
    z-index: 10;
    width: 100%;
    filter: drop-shadow(0 -10px 5px rgba(getcolour(bleach_black), 0.05));

    @include media-breakpoint-up(md) {
      padding: 0 40px;
    }
  }

  &__total-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    padding-top: 24px;

    // @include media-breakpoint-up(md) {
    //   margin-right: 35px;
    // }
  }

  &__total-amount {
    margin-left: 0.5em;
    &--strikethrough {
      position: relative;
      // text-decoration: line-through;
      color: getcolour(bleach_grey_60);
      &:after {
        content: "";
        position: absolute;
        width: 110%;
        height: 2px;
        top: 50%;
        left: 50%;
        transform-origin: center;
        transform: translate(-50%, -50%) rotate(-25deg);
        background-color: getcolour(bleach_grey_60);
      }
    }
  }

  &__total-checkout {
    &.basic-button {
      width: calc(100% + 35px);
      background: #b5e850;
      color: black;
      margin: 24px auto 0;
      padding: 17px 0;
      position: relative;
      left: -24px;
      height: auto;
      width: calc(100% + 48px);

      @include media-breakpoint-up(md) {
        left: -40px;
        width: calc(100% + 80px);
      }

      .basic-button__text {
        font-size: inherit;
        font-weight: inherit;
        color: black;
      }
    }

    &--disabled.basic-button {
      background: #d8d8d8;

      .basic-button__text {
        color: #9f9f9f;
      }
    }
  }
}
</style>
